module.exports = __webpack_public_path__ + "static/4-9ddba5d15edada71110a672fd404e013.jpg";